import { api } from 'shared/api';
import { ApiResponse } from 'shared/model/types';
import { EMI } from 'shared/model/types';

const _api = api.injectEndpoints({
  endpoints: (build) => ({
    startVerification: build.mutation<ApiResponse<unknown>, EMI>({
      query: (emi) => ({
        url: 'private/river/client/start-verification',
        method: 'GET',
        params: { emi },
      }),
    }),
  }),
});
export const { useStartVerificationMutation } = _api;
